import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getStatLottery = (params) => {
    return axios.get(`${backendHost}/api/admin/lottery/stat`, {params});
};

export {
    getStatLottery
}